import { NgFor, NgIf } from "@angular/common";
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, TrackByFunction } from "@angular/core";
import { CardModule } from "src/app/common/components/card/card.module";
import { IconModule } from "src/app/shared/ui/icon/icon.module";
import { TagComponent } from "src/app/shared/ui/tag/tag.component";
import { LaunchpadNewsCardProps } from "../../../container/launchpad.interfaces";

@Component({
  selector: "tpm-inner-news-card",
  templateUrl: "inner-news-card.component.html",
  styleUrls: ["inner-news-card.component.scss"],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf, NgFor, CardModule, TagComponent, IconModule]
})
export class InnerNewsCardComponent {
  @Output() readonly clicked = new EventEmitter<LaunchpadNewsCardProps>();

  @Input({ required: true }) props: LaunchpadNewsCardProps;

  readonly trackByIndex: TrackByFunction<LaunchpadNewsCardProps> = (index) => index;
}
